
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practice/analytics",
      function () {
        return require("private-next-pages/practice/analytics.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practice/analytics"])
      });
    }
  